export default "__VITE_ASSET__38ccad6d__"